export function modal(
  modalEl,
  modalContainerEl,
  modalBodyEl,
  modalButtonEl,
  modalCloseEl
) {

  //開くボタンをクリックしたらモーダルを表示する
  $(modalEl)
    .children(modalButtonEl)
    .on("click", function () {
      $(this).next(modalContainerEl).fadeIn();
    });

  // modalEl.on('click',function(){
  //   container.addClass('active');
  //   return false;
  // });
  //
  //閉じるボタンをクリックしたらモーダルを閉じる
  $(modalCloseEl).on('click',function(){
    $(modalContainerEl).fadeOut();
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(modalContainerEl).on('click',function(e) {
    if(!$(e.target).closest(modalBodyEl).length) {
      $(modalContainerEl).fadeOut();
    }
  });
}
